import { render, staticRenderFns } from "./CaseCard.vue?vue&type=template&id=2ea7e8b6&scoped=true&"
import script from "./CaseCard.vue?vue&type=script&lang=js&"
export * from "./CaseCard.vue?vue&type=script&lang=js&"
import style0 from "./CaseCard.vue?vue&type=style&index=0&id=2ea7e8b6&scoped=true&lang=css&"
import style1 from "./CaseCard.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ea7e8b6",
  null
  
)

export default component.exports